"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PlanningTab;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const CommonComponents_1 = require("../../View/Resultsets/CommonComponents");
const ScrumboardApi_1 = __importDefault(require("../ScrumboardApi"));
const useScrumboardEvents_1 = require("../useScrumboardEvents");
const vacationViewUtils_1 = require("../../Vacations/vacationViewUtils");
const FIELDS = [
    { key: "workingDays", label: "Dni pracy" },
    { key: "hoursPerDay", label: "Godz./dzień" },
    { key: "planningMeetingHours", label: "Planowanie" },
    { key: "retroMeetingHours", label: "Spotkanie końcowe" },
    { key: "extraMeetingsHours", label: "Dodatkowe" },
];
function available(entry) {
    return (entry.workingDays * entry.hoursPerDay -
        (entry.planningMeetingHours + entry.retroMeetingHours + entry.extraMeetingsHours));
}
/** Planowanie — odpowiednik arkusza "planowanie". Edycja per komórka na blur. */
function PlanningTab() {
    const [entries, setEntries] = (0, react_1.useState)([]);
    const [weekCounts, setWeekCounts] = (0, react_1.useState)(new Map());
    const [loading, setLoading] = (0, react_1.useState)(true);
    const [error, setError] = (0, react_1.useState)(null);
    async function load() {
        try {
            const [planning, counts] = await Promise.all([
                ScrumboardApi_1.default.getPlanning(),
                ScrumboardApi_1.default.getVacationWeekCounts(),
            ]);
            setEntries(planning);
            setWeekCounts(new Map(counts.map((c) => [c.personId, c])));
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setLoading(false);
        }
    }
    async function loadWeekCounts() {
        try {
            const counts = await ScrumboardApi_1.default.getVacationWeekCounts();
            setWeekCounts(new Map(counts.map((c) => [c.personId, c])));
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    (0, react_1.useEffect)(() => {
        load();
    }, []);
    (0, useScrumboardEvents_1.useScrumboardEvents)({
        "planning-changed": (payload) => {
            setEntries((prev) => prev.map((e) => (e.personId === payload.personId ? { ...e, ...payload.entry } : e)));
        },
        "absence-changed": loadWeekCounts,
    }, load);
    function updateLocal(personId, field, value) {
        setEntries((prev) => prev.map((e) => (e.personId === personId ? { ...e, [field]: value } : e)));
    }
    async function saveEntry(entry) {
        try {
            await ScrumboardApi_1.default.updatePlanning(entry.personId, {
                workingDays: entry.workingDays,
                hoursPerDay: entry.hoursPerDay,
                planningMeetingHours: entry.planningMeetingHours,
                retroMeetingHours: entry.retroMeetingHours,
                extraMeetingsHours: entry.extraMeetingsHours,
            });
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
    }
    if (loading)
        return react_1.default.createElement(CommonComponents_1.SpinnerBootstrap, null);
    if (error)
        return (react_1.default.createElement(react_bootstrap_1.Alert, { variant: "danger", dismissible: true, onClose: () => setError(null) }, error));
    return (react_1.default.createElement(react_bootstrap_1.Table, { bordered: true, hover: true, size: "sm", responsive: true },
        react_1.default.createElement("thead", null,
            react_1.default.createElement("tr", null,
                react_1.default.createElement("th", null, "Osoba"),
                FIELDS.map((f) => (react_1.default.createElement("th", { key: f.key }, f.label))),
                react_1.default.createElement("th", null, "Godz. w tygodniu"),
                react_1.default.createElement("th", { title: "Dni urlopu: tydzie\u0144 poprzedni / bie\u017C\u0105cy / nast\u0119pny" }, "Urlopy (pop./bie\u017C./nast.)"))),
        react_1.default.createElement("tbody", null, entries.map((entry) => (react_1.default.createElement("tr", { key: entry.personId },
            react_1.default.createElement("td", null, entry._person
                ? `${entry._person.name ?? ""} ${entry._person.surname ?? ""}`.trim()
                : entry.personId),
            FIELDS.map((f) => (react_1.default.createElement("td", { key: f.key, style: { maxWidth: 90 } },
                react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "number", min: 0, step: 0.5, size: "sm", value: entry[f.key], onChange: (e) => updateLocal(entry.personId, f.key, Number(e.target.value)), onBlur: () => saveEntry(entry) })))),
            react_1.default.createElement("td", { className: "fw-semibold" }, available(entry)),
            react_1.default.createElement("td", { className: "text-nowrap" }, (() => {
                // liczniki bywają ułamkowe (nieobecność na część dnia),
                // więc idą przez ten sam formatter co salda w zakładce Urlopy
                const c = weekCounts.get(entry.personId);
                return `${(0, vacationViewUtils_1.formatDays)(c?.prev ?? 0)} / ${(0, vacationViewUtils_1.formatDays)(c?.current ?? 0)} / ${(0, vacationViewUtils_1.formatDays)(c?.next ?? 0)}`;
            })())))))));
}
